import script from "./signalR.vue?vue&type=script&lang=js"
export * from "./signalR.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__